import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";

import { others, colors } from "../../styles/colors";
import {
  ErrorBox,
  GridItem,
  GridLayout,
  InvalidRequestCardSx,
  InvalidRequestContentGridSx,
  InvalidRequestErrorBoxSx,
  InvalidRequestLayoutSx,
  InvalidRequestSubtitleSx,
  InvalidRequestTitleSx,
} from "../styles/styles";

const InvalidRequestPage = () => {
  return (
    <GridLayout container sx={InvalidRequestLayoutSx}>
      <Grid size={{ xs: 12 }} sx={InvalidRequestContentGridSx}>
      <GridItem sx={InvalidRequestCardSx}>
        <ErrorBox sx={InvalidRequestErrorBoxSx}>
          <Typography
            variant="h1"
            color={others.otherColors[10]}
            fontWeight="fontWeightBold"
            fontSize={{ xs: "1.8rem", md: "2.3rem" }}
            lineHeight={1.15}
            sx={InvalidRequestTitleSx}
          >
            Invalid Request!
          </Typography>
          <Typography
            variant="h3"
            color={colors.primary.main}
            fontWeight="500"
            pt={"0.7rem"}
            pb={"0.4rem"}
            sx={InvalidRequestSubtitleSx}
          >
            Login failed.
          </Typography>
        </ErrorBox>
      </GridItem>
       </Grid>
    </GridLayout>
  );
};

export default InvalidRequestPage;
